/* ================================================================
   AISTROWISE — Cart-add upgrade (deferred, no libraries)

   Full-page POSTs to /cart/add (landing-page buy boxes) and raw
   /cart/add?id=<variant> permalinks (blog CTAs) give the Google &
   YouTube pixel only a bare variant id, so GA4 records add_to_cart
   with item_id "shopify_ZZ_undefined_<variant>" and no product name
   — half of all ATCs become unattributable.

   This shim upgrades both flows to the Cart AJAX API (/cart/add.js),
   the same path the PDP product form uses, so the pixel receives the
   full line item. UX is unchanged: on success we navigate to /cart
   (or the permalink's return_to). Progressive enhancement — with JS
   off, or if the fetch fails, the native form POST / link navigation
   proceeds exactly as before.

   Scope guards:
   - <product-form> forms are skipped (Dawn already AJAXes those).
   - Only same-origin /cart/add links; modified clicks (new tab etc.)
     are left native.
   ================================================================ */
(function () {
  'use strict';

  function addViaAjax(body, isJson, onDone, onFail) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: isJson ? { 'Content-Type': 'application/json' } : undefined,
      body: body,
    })
      .then(function (r) { if (!r.ok) throw new Error('cart/add.js ' + r.status); return r.json(); })
      .then(onDone)
      .catch(onFail);
  }

  // ── Buy-box forms (aw-specialty-body, aw-money-body, aw-horoscopo-body, aw-product) ──
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return; // Dawn PDP form AJAXes itself
    // Salida del shim: la usa el propio fallback nativo y también aw-spec-companion.js,
    // que la pone a los formularios de la landing mientras el compañero está marcado
    // para añadir las dos líneas en UNA sola petición (21-sep: dos escrituras a la vez
    // dejaban el carrito con una línea o sin el horóscopo).
    if (form.dataset.awNative) return;
    e.preventDefault();
    addViaAjax(new FormData(form), false, function () {
      window.location.href = '/cart';
    }, function () {
      form.dataset.awNative = '1';
      form.submit(); // native POST — degraded tracking, but the sale is never blocked
    });
  }, true);

  // ── /cart/add?id= permalinks (inline blog CTAs) ──
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (a.getAttribute('href') || '').indexOf('/cart/add') === -1) return;
    var url;
    try { url = new URL(a.href, window.location.origin); } catch (err) { return; }
    if (url.origin !== window.location.origin || !/\/cart\/add\/?$/.test(url.pathname)) return;
    var id = parseInt(url.searchParams.get('id'), 10);
    if (!id) return;
    e.preventDefault();
    var qty = parseInt(url.searchParams.get('quantity'), 10) || 1;
    addViaAjax(JSON.stringify({ items: [{ id: id, quantity: qty }] }), true, function () {
      window.location.href = url.searchParams.get('return_to') || '/cart';
    }, function () {
      window.location.href = a.href; // native permalink fallback
    });
  }, true);
})();
